import { Gift, Share2 } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { hapticLight } from "../../utils/haptics";
import { toast } from "sonner";

/**
 * FootballReferralCard — Refer & Earn card for football home. Uses the user's
 * unified APL referral code (shared with cricket). Rewards: 50 football + 25
 * cricket pts per friend.
 */
export default function FootballReferralCard() {
  const { dbUser } = useAuth();
  const code = dbUser?.referral_code || "APL-XXXXXX";

  const share = async () => {
    hapticLight();
    const origin = window.location.origin;
    const text = `Join me on APL Fantasy Sports for Football World Cup 2026! ⚽\n\nUse my code: ${code}\n${origin}/?ref=${code}`;
    try {
      if (navigator.share) {
        await navigator.share({ title: "APL Fantasy Sports", text });
      } else {
        window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
      }
    } catch { /* user cancelled */ }
  };

  const copyCode = async () => {
    try { await navigator.clipboard.writeText(code); toast.success("Referral code copied!"); } catch { /* ignore */ }
  };

  return (
    <div className="rounded-xl border border-amber-500/30 bg-gradient-to-br from-amber-900/20 to-orange-900/10 p-4" data-testid="football-referral-card">
      <div className="mb-2 flex items-center gap-2">
        <Gift className="h-5 w-5 text-amber-400" />
        <h3 className="text-sm font-bold">Refer & Earn</h3>
      </div>
      <p className="text-xs text-muted-foreground">Invite friends to APL. Earn <strong className="wc-gold">10 football pts + 25 cricket pts</strong> per friend who joins (max 3/week).</p>
      <div className="mt-3 flex items-center gap-2">
        <button onClick={copyCode} className="flex-1 truncate rounded-lg border border-border bg-card px-3 py-2 text-left text-sm font-extrabold tracking-wide" data-testid="football-referral-code">
          {code}
        </button>
        <button onClick={share} className="flex items-center gap-1.5 rounded-lg wc-bg-gold px-4 py-2 text-sm font-extrabold text-slate-900" data-testid="football-referral-share">
          <Share2 size={15} /> Share
        </button>
      </div>
    </div>
  );
}
